import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

type State = {
  deletableCategory: {
    id: number;
    title: string;
  } | null;
  setDeletableCategory: (
    category: {
      id: number;
      title: string;
    } | null,
  ) => void;
};

export const useCategoriesStore = create<State>()(
  subscribeWithSelector(
    immer((set) => ({
      deletableCategory: null,
      setDeletableCategory(category) {
        return set((state) => {
          state.deletableCategory = category;
        });
      },
    })),
  ),
);
